/**
 * A key identifying ONE payment attempt, sent to the backend and on to Stripe.
 *
 * Two clicks on Accept Payment used to become two separate PaymentIntents and
 * two real charges — a member was charged $60 twice, 7.6 seconds apart. Stripe
 * collapses a replayed key onto the first intent, so both clicks settle as one
 * charge.
 *
 * Hold the key for the DURATION of one attempt, not for the life of the form:
 * a second click while the request is outstanding reuses it, but a retry after
 * a failure gets a fresh one — Stripe rejects a reused key whose parameters
 * changed, so a permanent key would turn "card declined, try $50 instead" into
 * an idempotency error.
 *
 * crypto.randomUUID is unavailable over plain http and in some test
 * environments, so fall back rather than throwing inside a payment handler.
 */
export const newAttemptKey = (): string => {
  try {
    if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
      return crypto.randomUUID();
    }
  } catch {
    /* fall through */
  }
  return `attempt-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
};
